<template>
  <div
    class="flex flex-col justify-between w-full max-w-lg overflow-hidden bg-gray-700 md:sticky md:rounded-lg md:left-4 md:top-4 font-poppins md:h-test h-full min-h-screen"
    style="
      min-height: -webkit-fill-available;
      max-height: -webkit-fill-available;
    "
  >
    <div class="relative px-2 mb-20 overflow-y-auto flex-1">
      <!-- Top Navigation -->
      <div class="py-4 border-b-2">
        <div class="flex items-center justify-between">
          <div
            class="mb-1 text-xs font-bold leading-tight tracking-wide text-gray-400 uppercase"
            v-text="
              `${$t('dataComposition.steps.label')}: ${step} ${$t(
                'dataComposition.steps.of'
              )} 6`
            "
          ></div>
          <div class="w-8/12 mr-2 bg-white rounded-full">
            <div
              class="h-2 text-xs leading-none text-center text-white bg-green-500 rounded-full"
              :style="'width: ' + parseInt((step / 6) * 100) + '%'"
            ></div>
          </div>
        </div>

        <div
          class="flex flex-col md:flex-row md:items-center md:justify-between"
        >
          <div class="flex-1">
            <div v-show="step === 1">
              <div class="font-bold leading-tight text-gray-100">
                {{ $t("dataComposition.basics.label_basics") }}
              </div>
            </div>
            <div v-show="step === 2">
              <div class="font-bold leading-tight text-gray-100">
                {{ $t("dataComposition.basics.label_contact") }}
              </div>
            </div>
            <div v-show="step === 3">
              <div class="font-bold leading-tight text-gray-100">
                {{ $t("dataComposition.skills.label") }}
              </div>
            </div>
            <div v-show="step === 4">
              <div class="font-bold leading-tight text-gray-100">
                {{ $t("dataComposition.education.label") }}
              </div>
            </div>
            <div v-show="step === 5">
              <div class="font-bold leading-tight text-gray-100">
                {{ $t("dataComposition.experience.label") }}
              </div>
            </div>
            <div v-show="step === 6">
              <div class="font-bold leading-tight text-gray-100">
                {{ $t("dataComposition.steps.optional_label") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Top Navigation -->

      <div class="w-full h-full">
        <!-- component 1 -->
        <transition-group
          enter-active-class="transition duration-300 ease-linear "
          enter-class="opacity-0"
          enter-to-class="opacity-100 "
          leave-active-class="transition duration-300 "
          leave-class="opacity-100 "
          leave-to-class="opacity-0"
          mode="in-out"
        >
          <div class="w-full h-full px-2" v-show="step === 1" :key="1 + '2'">
            <div class="my-5">
              <label
                for="firstname"
                class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                >{{ $t("dataComposition.basics.name") }}</label
              >
              <input
                type="text"
                class="w-full text-sm text-white bg-gray-600 border-gray-700 form-input h-9"
                v-model="basics.name"
                @input="updateStore($event, 'nombre')"
                :placeholder="$t('dataComposition.basics.name_placeholder')"
              />
            </div>
            <div class="mb-5">
              <label
                for="firstname"
                class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                >{{ $t("dataComposition.basics.label") }}</label
              >
              <input
                type="text"
                class="w-full text-sm text-white bg-gray-600 border-gray-700 form-input h-9"
                @input="updateStore($event, 'titulo')"
                v-model="basics.label"
                :placeholder="$t('dataComposition.basics.label_placeholder')"
              />
            </div>
            <div class="mb-5">
              <label
                for="firstname"
                class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                >{{ $t("dataComposition.basics.summary") }}</label
              >
              <div class>
                <editor
                  @input="updateStore($event, 'bio')"
                  :newSetData="basics.summary"
                  ref="sansil"
                ></editor>
              </div>
            </div>
            <div class="w-full mb-20 text-center">
              <div
                class="relative w-32 h-32 mx-auto mb-4 bg-gray-100 border rounded-full shadow-inset"
              >
                <img
                  id="image"
                  class="object-cover w-full h-32 rounded-full"
                  :src="image"
                />
              </div>

              <label
                class="px-3 py-3 text-sm text-gray-200 bg-gray-600 rounded-lg cursor-pointer focus:outline-none hover:bg-gray-500"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="inline-flex flex-shrink-0 w-6 h-6 mr-1 -mt-1"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="0" y="0" width="24" height="24" stroke="none" />
                  <path
                    d="M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
                  />
                  <circle cx="12" cy="13" r="3" />
                </svg>
                {{ $t("dataComposition.basics.imageUplaod") }}
                <input
                  name="photo"
                  id="fileInput"
                  accept="image/*"
                  class="hidden"
                  type="file"
                  @change="onImageUpload"
                />
              </label>
            </div>
          </div>

          <!-- step 2 -->

          <div class="w-full h-full px-2" v-show="step === 2" :key="2">
            <div class="my-5">
              <label
                for="firstname"
                class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                >{{ $t("dataComposition.basics.email") }}</label
              >
              <input
                type="text"
                class="w-full text-sm text-white bg-gray-600 border-gray-700 form-input h-9"
                @input="updateStore($event, 'email')"
                v-model="basics.email"
                :placeholder="$t('dataComposition.basics.email_placeholder')"
              />
            </div>
            <div class="mb-5">
              <label
                for="firstname"
                class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                >{{ $t("dataComposition.basics.phone") }}</label
              >
              <input
                type="text"
                class="w-full text-sm text-white bg-gray-600 border-gray-700 form-input h-9"
                @input="updateStore($event, 'celular')"
                v-model="basics.phone"
                :placeholder="$t('dataComposition.basics.phone_placeholder')"
              />
            </div>
            <div class="mb-5">
              <label
                for="firstname"
                class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                >{{ $t("dataComposition.basics.address") }}</label
              >
              <input
                type="text"
                class="w-full text-sm text-white bg-gray-600 border-gray-700 form-input h-9"
                @input="updateStore($event, 'direccion')"
                v-model="basics.location.address"
                :placeholder="$t('dataComposition.basics.address_placeholder')"
              />
            </div>
            <div class="mb-5">
              <label
                for="firstname"
                class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                >{{ $t("dataComposition.basics.birthday") }}</label
              >
              <input
                type="text"
                class="w-full text-sm text-white bg-gray-600 border-gray-700 form-input h-9"
                @input="updateStore($event, 'nacimiento')"
                v-model="basics.birthday"
                :placeholder="$t('dataComposition.basics.birthday_placeholder')"
              />
            </div>
          </div>

          <!-- step 3 -->

          <div class="w-full h-full mt-5 px-2" v-show="step === 3" :key="3">
            <r-linput-tag v-model="habilidades" class="mt-4">
              <div
                slot-scope="{
                  tags,
                  addTag,
                  removeTag,
                  inputAttrs,
                  inputEvents,
                }"
                class
              >
                <div class="flex">
                  <input
                    class="w-full text-sm text-white bg-gray-600 border-gray-700 form-input h-9"
                    :placeholder="$t('dataComposition.skills.placeholder')"
                    v-on="inputEvents"
                    v-bind="inputAttrs"
                  />
                  <button
                    type="button"
                    class="px-3 ml-2 text-sm text-gray-200 bg-gray-600 rounded-lg focus:outline-none hover:bg-gray-500"
                    @click="addTag"
                  >
                    {{ $t("dataComposition.skills.button") }}
                  </button>
                </div>

                <ul v-show="tags.length > 0" class="pl-6 mt-4">
                  <li
                    v-for="(tag, index) in tags"
                    class="flex items-end mb-2"
                    :key="index"
                  >
                    <span class="mr-2 leading-6 text-gray-100">{{ tag }}</span>
                    <button
                      class="px-1 text-sm text-gray-600 rounded-sm focus:outline-none hover:text-gray-500"
                      @click="removeTag(tag)"
                    >
                      <svg
                        class="w-5 h-5 text-red-400 hover:text-red-300"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </button>
                  </li>
                </ul>
              </div>
            </r-linput-tag>
            <div class="py-4 border-b-2">
              <div
                class="flex flex-col md:flex-row md:items-center md:justify-between"
              >
                <div class="flex items-center flex-1">
                  <div
                    class="font-bold leading-tight tracking-wide text-gray-100"
                  >
                    {{ $t("dataComposition.idioms.label") }}
                  </div>
                  <switcher
                    :toggleSwitch="toggleIdiomsSwitch"
                    @toggle="
                      $store.dispatch('updateControl', {
                        idioms: !!!toggleIdiomsSwitch,
                      });
                      toggleIdiomsSwitch = !!!toggleIdiomsSwitch;
                    "
                    class="ml-1.5"
                  ></switcher>
                </div>
              </div>
            </div>
            <transition-group
              enter-active-class="transition duration-300  ease-out"
              enter-class="opacity-0 translate-y-2"
              enter-to-class="opacity-100 translate-y-0 "
              leave-active-class="transition duration-300 ease-in "
              leave-class="opacity-100 "
              leave-to-class="opacity-0 "
              move-class="transition duration-300"
            >
              <div
                class="grid grid-cols-2 gap-4 my-3"
                v-for="(idiom, index) in newIdioms"
                :key="index + 'c'"
              >
                <div class="col-span-1">
                  <label
                    for="firstname"
                    class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                    >{{ $t("dataComposition.idioms.idiom") }}</label
                  >
                  <input
                    type="text"
                    class="w-full text-sm text-white bg-gray-600 border-gray-700 form-input h-9"
                    v-model="idiom.name"
                    @input="updateStore(index, 'idioma')"
                    :placeholder="$t('dataComposition.idioms.placeholder')"
                  />
                </div>
                <div class="col-span-1">
                  <label
                    for="firstname"
                    class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                    >{{ $t("dataComposition.idioms.level") }}</label
                  >
                  <select
                    type="text"
                    class="w-full text-sm text-white bg-gray-600 border-gray-700 form-select h-9"
                    placeholder="1"
                    v-model="idiom.level"
                    @change="updateStore(index, 'idioma')"
                  >
                    <option v-for="(level, index) in idiomsLevels" :key="index">
                      {{ level }}
                    </option>
                  </select>
                </div>
              </div>
            </transition-group>

            <span class="flex my-5 space-x-2">
              <button
                @click="addIdiom"
                class="flex items-center px-3 py-2 text-sm text-gray-200 bg-gray-600 rounded-lg focus:outline-none hover:bg-gray-500"
              >
                <svg
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  class="flex-shrink-0 w-5 h-5 mr-1"
                >
                  <path
                    d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span>{{ $t("dataComposition.idioms.button") }}</span>
              </button>
              <button
                v-if="newIdioms.length > 1"
                @click="deleteIdiom"
                class="px-3 py-2 text-sm text-gray-300 border border-gray-300 rounded-lg focus:outline-none hover:text-gray-100 hover:border-gray-100"
              >
                {{ $t("dataComposition.idioms.button_delete") }}
              </button>
            </span>
          </div>

          <!-- step 4 -->

          <div
            class="w-full h-full mt-5 px-2 overflow-y-auto"
            v-show="step === 4"
            :key="4"
          >
            <div class="divide-y-4 divide-gray-500">
              <transition-group
                enter-active-class="transition duration-300  ease-out"
                enter-class="opacity-0 translate-y-2"
                enter-to-class="opacity-100 translate-y-0 "
                leave-active-class="transition duration-300 ease-in "
                leave-class="opacity-100 "
                leave-to-class="opacity-0 "
                move-class="transition duration-300"
                tag="div"
                class="divide-y-4 divide-gray-500"
              >
                <div v-for="(edu, index) in educacion" :key="index + 'a'" class>
                  <div class="grid grid-cols-4 gap-2 my-4">
                    <div class="col-span-2">
                      <label
                        for="firstname"
                        class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                        >{{ $t("dataComposition.education.title") }}</label
                      >
                      <input
                        type="text"
                        class="w-full text-sm text-white bg-gray-600 border-gray-700 form-input h-9"
                        @input="updateStore($event, 'educacion')"
                        v-model="edu.studyType"
                        :placeholder="
                          $t('dataComposition.education.title_placeholder')
                        "
                      />
                    </div>
                    <div class>
                      <label
                        for="firstname"
                        class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide truncate"
                        >{{ $t("dataComposition.education.start_date") }}</label
                      >
                      <input
                        type="text"
                        class="w-full text-sm italic text-white bg-gray-600 border-gray-700 form-input h-9"
                        v-model="edu.startDate"
                        @input="updateStore($event, 'educacion')"
                        :placeholder="
                          $t('dataComposition.education.start_date_placeholder')
                        "
                      />
                    </div>
                    <div class>
                      <label
                        for="firstname"
                        class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                        >{{ $t("dataComposition.education.end_date") }}</label
                      >
                      <input
                        type="text"
                        class="w-full text-sm italic text-white bg-gray-600 border-gray-700 form-input h-9"
                        v-model="edu.endDate"
                        @input="updateStore($event, 'educacion')"
                        :placeholder="
                          $t('dataComposition.education.end_date_placeholder')
                        "
                      />
                    </div>
                  </div>
                  <div class="mb-2">
                    <label
                      for="firstname"
                      class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                      >{{ $t("dataComposition.education.summary") }}</label
                    >
                    <div class>
                      <editor
                        @input="updateStore($event, 'educacion')"
                        :newSetData="
                          summaryEducationImported[index].institution
                        "
                        v-model="edu.institution"
                      ></editor>
                    </div>
                  </div>
                  <div class="relative flex items-start mb-5">
                    <div class="flex items-center h-5">
                      <input
                        id="isCourse"
                        type="checkbox"
                        v-model="edu.isCourse"
                        class="form-checkbox h-4 w-4 text-blue-600 transition duration-150 ease-in-out"
                      />
                    </div>
                    <div class="ml-3 text-sm leading-5">
                      <label for="comments" class="font-medium text-gray-100">{{
                        $t("dataComposition.education.is_course")
                      }}</label>
                    </div>
                  </div>
                </div>
              </transition-group>
            </div>

            <span class="flex my-5 space-x-2">
              <button
                @click="addEducation"
                class="flex items-center px-3 py-2 text-sm text-gray-200 bg-gray-600 rounded-lg focus:outline-none hover:bg-gray-500"
              >
                <svg
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  class="flex-shrink-0 w-5 h-5 mr-1 hover:text-gray-600"
                >
                  <path
                    d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span>{{ $t("dataComposition.education.button") }}</span>
              </button>
              <button
                v-if="educacion.length > 1"
                @click="deleteEducation"
                class="px-3 py-2 text-sm text-gray-300 border border-gray-300 rounded-lg focus:outline-none hover:text-gray-100 hover:border-gray-100"
              >
                {{ $t("dataComposition.education.button_delete") }}
              </button>
            </span>
          </div>

          <!-- setp 5 -->

          <div class="w-full h-full my-5 px-2" v-show="step === 5" :key="5">
            <transition-group
              enter-active-class="transition duration-300  ease-out"
              enter-class="opacity-0 translate-y-2"
              enter-to-class="opacity-100 translate-y-0 "
              leave-active-class="transition duration-300 ease-in "
              leave-class="opacity-100 "
              leave-to-class="opacity-0 "
              move-class="transition duration-300"
              tag="div"
              class="divide-y-4 divide-gray-500"
            >
              <div v-for="(exp, index) in work" :key="index + 's'" class>
                <div class="mt-3">
                  <label
                    for="firstname"
                    class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                    >{{ $t("dataComposition.experience.position") }}</label
                  >
                  <input
                    type="text"
                    class="w-full text-sm text-white bg-gray-600 border-gray-700 form-input h-9"
                    @input="updateStore($event, 'work')"
                    v-model="exp.position"
                    :placeholder="
                      $t('dataComposition.experience.position_placeholder')
                    "
                  />
                </div>
                <div class="grid grid-cols-4 gap-2 my-4">
                  <div class="col-span-2">
                    <label
                      for="firstname"
                      class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                      >{{ $t("dataComposition.experience.company") }}</label
                    >
                    <input
                      type="text"
                      class="w-full text-sm text-white bg-gray-600 border-gray-700 form-input h-9"
                      @input="updateStore($event, 'work')"
                      v-model="exp.name"
                      :placeholder="
                        $t('dataComposition.experience.company_placeholder')
                      "
                    />
                  </div>
                  <div class>
                    <label
                      for="firstname"
                      class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide truncate"
                      >{{ $t("dataComposition.experience.start_date") }}</label
                    >
                    <input
                      type="text"
                      class="w-full text-sm italic text-white bg-gray-600 border-gray-700 form-input h-9"
                      v-model="exp.startDate"
                      @input="updateStore($event, 'work')"
                      :placeholder="
                        $t('dataComposition.experience.start_date_placeholder')
                      "
                    />
                  </div>
                  <div class>
                    <label
                      for="firstname"
                      class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                      >{{ $t("dataComposition.experience.end_date") }}</label
                    >
                    <input
                      type="text"
                      class="w-full text-sm italic text-white bg-gray-600 border-gray-700 form-input h-9"
                      v-model="exp.endDate"
                      @input="updateStore($event, 'work')"
                      :placeholder="
                        $t('dataComposition.experience.end_date_placeholder')
                      "
                    />
                  </div>
                </div>
                <div class="mb-5">
                  <label
                    for="firstname"
                    class="font-semibold text-sm mb-1.5 text-gray-100 block tracking-wide"
                    >{{ $t("dataComposition.experience.summary") }}</label
                  >
                  <div class>
                    <editor
                      @input="updateStore($event, 'work')"
                      v-model="exp.summary"
                      :newSetData="summaryWorkImported[index].summary"
                    ></editor>
                  </div>
                </div>
              </div>
            </transition-group>

            <span class="flex my-5 space-x-2">
              <button
                @click="addExperience"
                class="flex items-center px-3 py-2 text-sm text-gray-200 bg-gray-600 rounded-lg focus:outline-none hover:bg-gray-500"
              >
                <svg
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  class="flex-shrink-0 w-5 h-5 mr-1 hover:text-gray-600"
                >
                  <path
                    d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span>{{ $t("dataComposition.experience.button") }}</span>
              </button>
              <button
                v-if="work.length > 1"
                @click="deleteExperience"
                class="px-3 py-2 text-sm text-gray-300 border border-gray-300 rounded-lg ocus:outline-none hover:text-gray-100 hover:border-gray-100"
              >
                {{ $t("dataComposition.experience.button_delete") }}
              </button>
            </span>
          </div>

          <!-- setp 6 -->

          <div class="w-full mt-2 h-full px-2" v-show="step === 6" :key="6">
            <!-- <div class="py-4 border-b-2">
              <div class="flex flex-col md:flex-row md:items-center md:justify-between">
                <div class="flex items-center flex-1">
                  <div class="font-bold leading-tight text-gray-100">Intereses</div>
                  <switcher
                    class="ml-2"
                    :toggleSwitch="toggleInterestSwitch"
                    @toggle="$store.dispatch('updateControl',{'interests':!!!toggleInterestSwitch});toggleInterestSwitch=!!!toggleInterestSwitch"
                  ></switcher>
                </div>
              </div>
            </div>-->
            <div class="py-4 border-b-2">
              <div
                class="flex flex-col md:flex-row md:items-center md:justify-between"
              >
                <div class="flex items-center flex-1">
                  <div
                    class="font-bold leading-tight tracking-wide text-gray-100"
                  >
                    {{ $t("dataComposition.interests.label") }}
                  </div>
                  <switcher
                    class="ml-2"
                    :toggleSwitch="toggleInterestSwitch"
                    @toggle="
                      $store.dispatch('updateControl', {
                        interests: !toggleInterestSwitch,
                      });
                      toggleInterestSwitch = !toggleInterestSwitch;
                    "
                  ></switcher>
                </div>
              </div>
            </div>
            <r-linput-tag v-model="interests" class="mt-4">
              <div
                slot-scope="{
                  tags,
                  addTag,
                  removeTag,
                  inputAttrs,
                  inputEvents,
                }"
                class
              >
                <div class="flex">
                  <input
                    class="w-full text-sm text-white bg-gray-600 border-gray-700 form-input h-9"
                    :placeholder="$t('dataComposition.interests.placeholder')"
                    v-on="inputEvents"
                    v-bind="inputAttrs"
                  />
                  <button
                    type="button"
                    class="px-3 ml-2 text-sm text-gray-200 bg-gray-600 rounded-lg focus:outline-none hover:bg-gray-500"
                    @click="addTag"
                  >
                    {{ $t("dataComposition.interests.button") }}
                  </button>
                </div>

                <ul v-show="tags.length > 0" class="pl-6 mt-4">
                  <li
                    v-for="(tag, index) in tags"
                    class="flex items-end mb-2"
                    :key="index"
                  >
                    <span class="mr-2 leading-6 text-gray-100">{{ tag }}</span>
                    <button
                      class="px-1 text-sm text-gray-600 rounded-sm focus:outline-none hover:text-gray-500"
                      @click="removeTag(tag)"
                    >
                      <svg
                        class="w-5 h-5 text-red-400 hover:text-red-300"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </button>
                  </li>
                </ul>
              </div>
            </r-linput-tag>
            <div>
              <div class="py-4 mt-2 border-b-2">
                <div
                  class="flex flex-col md:flex-row md:items-center md:justify-between"
                >
                  <div class="flex items-center flex-1">
                    <div class="font-bold leading-tight text-gray-100">
                      {{ $t("dataComposition.projects.label") }}
                    </div>
                    <switcher
                      class="ml-2"
                      :toggleSwitch="toggleProyectsSwitch"
                      @toggle="
                        $store.dispatch('updateControl', {
                          projects: !toggleProyectsSwitch,
                        });
                        toggleProyectsSwitch = !toggleProyectsSwitch;
                      "
                    ></switcher>
                  </div>
                </div>
              </div>
              <div class="mt-4">
                <editor
                  @input="updateStore($event, 'projects')"
                  :newSetData="projects"
                  ref="sansil"
                ></editor>
              </div>
            </div>
            <div>
              <div class="py-4 border-b-2">
                <div
                  class="flex flex-col md:flex-row md:items-center md:justify-between"
                >
                  <div class="flex items-center flex-1">
                    <div class="font-bold leading-tight text-gray-100">
                      {{ $t("dataComposition.references.label") }}
                    </div>
                    <switcher
                      class="ml-2"
                      :toggleSwitch="toggleReferencesSwitch"
                      @toggle="
                        $store.dispatch('updateControl', {
                          references: !toggleReferencesSwitch,
                        });
                        toggleReferencesSwitch = !toggleReferencesSwitch;
                      "
                    ></switcher>
                  </div>
                </div>
              </div>
              <div class="mt-4">
                <editor
                  @input="updateStore($event, 'references')"
                  :newSetData="references"
                  ref="sansil"
                ></editor>
              </div>
            </div>
            <div class="py-4 border-b-2">
              <div
                class="flex flex-col md:flex-row md:items-center md:justify-between"
              >
                <div class="flex items-center flex-1">
                  <div
                    class="font-bold leading-tight tracking-wide text-gray-100"
                  >
                    {{ $t("dataComposition.otherData.label") }}
                  </div>
                  <switcher
                    class="ml-2"
                    :toggleSwitch="toggleOtherDataSwitch"
                    @toggle="
                      $store.dispatch('updateControl', {
                        otherData: !toggleOtherDataSwitch,
                      });
                      toggleOtherDataSwitch = !toggleOtherDataSwitch;
                    "
                  ></switcher>
                </div>
              </div>
            </div>
            <r-linput-tag v-model="otrosDatos" class="mt-4">
              <div
                slot-scope="{
                  tags,
                  addTag,
                  removeTag,
                  inputAttrs,
                  inputEvents,
                }"
                class
              >
                <div class="flex">
                  <input
                    class="w-full text-sm text-white bg-gray-600 border-gray-700 form-input h-9"
                    :placeholder="$t('dataComposition.otherData.placeholder')"
                    v-on="inputEvents"
                    v-bind="inputAttrs"
                  />
                  <button
                    type="button"
                    class="px-3 ml-2 text-sm text-gray-200 bg-gray-600 rounded-lg focus:outline-none hover:bg-gray-500"
                    @click="addTag"
                  >
                    {{ $t("dataComposition.otherData.button") }}
                  </button>
                </div>

                <ul v-show="tags.length > 0" class="pl-6 mt-4">
                  <li
                    v-for="(tag, index) in tags"
                    class="flex items-end mb-2"
                    :key="index"
                  >
                    <span class="mr-2 leading-6 text-gray-100">{{ tag }}</span>
                    <button
                      class="px-1 text-sm text-gray-600 rounded-sm focus:outline-none hover:text-gray-500"
                      @click="removeTag(tag)"
                    >
                      <svg
                        class="w-5 h-5 text-red-400 hover:text-red-300"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </button>
                  </li>
                </ul>
              </div>
            </r-linput-tag>
          </div>
          <!-- <div class="w-full h-full mt-2" v-show="step===7" :key="7">
            <div class="flex items-center justify-center w-full h-full mt-16">
              <button
                class="flex items-center px-5 py-2 space-x-2 bg-blue-500 rounded-lg group hover:bg-gray-500 focus:outline-none hover:text-gray-50"
                @click="$emit('print')"
              >
                <svg
                  class="relative flex-shrink-0 text-blue-200 w-7 h-7 group-hover:text-gray-200"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
                  />
                </svg>
                <span class="text-xl font-medium text-blue-100">Exportar a PDF</span>
              </button>
            </div>
          </div>-->
        </transition-group>
      </div>
    </div>
    <!-- botones avanzar -->
    <div
      class="absolute bottom-0 w-full h-20 max-w-lg px-4 py-4 bg-gray-600 border-t border-gray-700 shadow-md md:rounded-b-lg"
      v-show="step != 'complete'"
    >
      <div class="md:px-4">
        <div class="flex justify-between">
          <div class>
            <button
              v-show="step > 1"
              @click="step--"
              class="px-5 py-2 font-medium text-center text-gray-600 bg-white border rounded-lg shadow-sm focus:outline-none hover:bg-gray-100"
            >
              {{ $t("dataComposition.buttons.prev") }}
            </button>
          </div>

          <div class="text-right">
            <button
              v-show="step < 6"
              @click="step++"
              class="w-32 px-5 py-2 font-medium text-center text-white bg-blue-500 border border-transparent rounded-lg shadow-sm focus:outline-none hover:bg-blue-600"
            >
              {{ $t("dataComposition.buttons.next") }}
            </button>
            <button
              v-show="step >= 6"
              class="inline-flex items-center justify-center px-5 py-2 space-x-2 font-medium text-white bg-green-500 border border-transparent rounded-lg shadow-sm focus:outline-none hover:bg-green-600"
              @click="$emit('print')"
            >
              <svg
                class="relative flex-shrink-0 w-5 h-5 text-green-200 md:w-6 md:h-6 group-hover:text-green-200"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
                />
              </svg>
              <span class="font-medium text-green-100 truncate">{{
                $t("dataComposition.buttons.export")
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import RLinputTag from "@/components/renderless/RLinputTag.vue";
import Editor from "@/components/Editor.vue";
import Switcher from "@/components/Switcher";
import EventBus from "@/eventBus";
export default {
  props: {
    height: {
      default: "height:calc(100vh - 3rem)",
    },
  },
  data() {
    return {
      step: 1,
      toggleIdiomsSwitch: true,
      toggleInterestSwitch: true,
      toggleOtherDataSwitch: true,
      toggleProyectsSwitch: false,
      toggleReferencesSwitch: false,
      image: require("@/assets/profile.svg"),
      newIdioms: [{ name: "", level: "" }],
      interests: [],
      otrosDatos: [],
      habilidades: [],
      educacion: [
        {
          name: "",
          fechaInicio: "",
          fechaFin: "",
          institution: "",
          isCourse: false,
        },
      ],
      name: "ANTEL",
      basics: {
        name: "",
        summary: "",
        label: "",
        location: {
          address: "",
        },
        email: "",
        phone: "",
        birthday: "",
      },
      work: [
        {
          position: "",
          startDate: "",
          name: "",
          tasks: "",
          endDate: "",
          summary: "",
          url: "",
          highlights: [],
        },
      ],
      summaryWorkImported: [{ summary: "" }],
      summaryEducationImported: [{ institution: "" }],
      idiomsLevels: [1, 2, 3, 4, 5],
      projects: "",
      references: "",
    };
  },
  components: {
    RLinputTag,
    Editor,
    Switcher,
  },
  watch: {
    interests: async function () {
      await this.$nextTick();
      this.updateInterests(this.interests);
    },
    habilidades: async function () {
      await this.$nextTick();
      this.updateSkills(
        this.habilidades.map((skill) => {
          return { name: skill };
        })
      );
    },
    otrosDatos: async function () {
      await this.$nextTick();
      this.updateOtherData(this.otrosDatos);
    },
  },
  mounted() {
    EventBus.$on("CURRICULUM_LOADED", (payload) => {
      this.educacion = payload.education;
      this.basics = payload.basics;
      this.interests = payload.interests;
      this.habilidades = payload.skills.map((s) => s.name);
      this.otrosDatos = payload.otherData;
      this.work = payload.work;
      this.idioms = payload.idioms;
      this.projects = payload.projects;
      this.references = payload.references;
      this.summaryWorkImported = [];
      this.toggleProyectsSwitch = payload.control.projects;
      this.toggleIdiomsSwitch = payload.control.idioms;
      this.toggleInterestSwitch = payload.control.interests;
      this.toggleOtherDataSwitch = payload.control.otherData;
      this.toggleReferencesSwitch = payload.control.references;
      this.work.forEach((w) => {
        this.summaryWorkImported.push({ summary: w.summary });
      });
      this.summaryEducationImported = [];
      this.educacion.forEach((e) => {
        this.summaryEducationImported.push({ institution: e.institution });
      });
    });
  },
  beforeDestroy() {
    EventBus.$off("CURRICULUM_LOADED");
  },
  methods: {
    ...mapActions([
      "updateBioinfo",
      "updateBasics",
      "updateIdioms",
      "updateSkills",
      "updateInterests",
      "updateEducation",
      "updateWork",
      "updateOtherData",
      "updateProyects",
      "updateReferences",
    ]),
    addIdiom() {
      this.newIdioms.push({ name: "", level: "" });
    },
    deleteIdiom() {
      this.newIdioms.pop();
    },
    addEducation() {
      this.educacion.push({
        name: "",
        fechaInicio: "",
        fechaFin: "",
        institution: "",
        isCourse: false,
      });
      this.summaryEducationImported.push({ institution: "" });
    },
    deleteEducation() {
      this.educacion.pop();
    },
    addExperience() {
      this.work.push({ position: "", date: "", company: "", tasks: "" });
      this.summaryWorkImported.push({ summary: "" });
    },
    deleteExperience() {
      this.work.pop();
    },
    async onImageUpload() {
      let file = document.getElementById("fileInput").files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
        this.updateStore(this.image, "imageProfile");
      };
      await reader.readAsDataURL(file);
    },
    async updateStore(event, variable) {
      switch (variable) {
        case "nombre":
          this.updateBasics({ name: event.target.value });
          break;
        case "titulo":
          this.updateBasics({ label: event.target.value });
          break;
        case "bio":
          //console.log(event);
          this.updateBasics({ summary: event });
          break;
        case "imageProfile":
          this.updateBioinfo({ image: event });
          break;
        case "email":
          this.updateBasics({ email: event.target.value });
          break;
        case "direccion":
          this.updateBasics({ location: { address: event.target.value } });
          break;
        case "celular":
          this.updateBasics({ phone: event.target.value });
          break;
        case "nacimiento":
          this.updateBasics({ birthday: event.target.value });
          break;
        case "idioma":
          await this.$nextTick();
          this.updateIdioms(this.newIdioms);
          break;
        case "educacion":
          await this.$nextTick();
          this.updateEducation(this.educacion);
          break;
        case "work":
          await this.$nextTick();
          this.updateWork(this.work);
          break;
        case "projects":
          this.updateProyects(event);
          break;
        case "references":
          this.updateReferences(event);
          break;
        default:
          break;
      }
    },
    loadProfileImage() {
      // if (this.trabajador.imagen != null) {
      //   return process.env.VUE_APP_ROOT_UPLOADS + this.trabajador.imagen;
      // }
      return require("@/assets/profile.svg");
    },
  },
};
</script>

<style lang="scss" scoped>
.scroller {
  overflow-y: scroll;
}

.test-font {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
</style>